var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2929 27.2L25.2341 27.2C25.9829 27.2 26.7011 26.905 27.2306 26.3799C27.7601 25.8548 28.0576 25.1426 28.0576 24.4L28.0576 7.60001C28.0576 6.85741 27.7601 6.14522 27.2306 5.62011C26.7011 5.09501 25.9829 4.80001 25.2341 4.80001L20.2929 4.80001M19.942 16L3.94199 16M3.94199 16L10.0555 22.4M3.94199 16L10.0555 9.60001",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.25586ea66c1bd5aa346fdef11e78b074.svg";
export { ForwardRef as ReactComponent };